"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var basicTheme = require("../basicForm/theme.scss");
var theme = require("./theme.scss");
var ui_1 = require("@vidazoo/ui");
var linkButton_1 = require("@vidazoo/ui/lib/components/linkButton");
var modal_1 = require("@vidazoo/ui/lib/components/modal");
var Recaptcha = require("react-recaptcha");
var LoginLink = function (_a) {
    var onLogin = _a.onLogin;
    return (React.createElement("div", { className: basicTheme.footerLink },
        "Return to ",
        React.createElement("a", { onClick: onLogin }, "sign in")));
};
var TwoFactorForm = /** @class */ (function (_super) {
    tslib_1.__extends(TwoFactorForm, _super);
    function TwoFactorForm(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onInputChange = function (e) {
            var key = e.target.name;
            var nextState = {};
            nextState[key] = e.target.value;
            _this.setState(nextState);
        };
        _this.onLoginClick = function () {
            var _a = _this.props, onLoginClick = _a.onLoginClick, setTwoFactorAuthentication = _a.setTwoFactorAuthentication;
            setTwoFactorAuthentication(false);
            onLoginClick();
        };
        _this.onVerifyToken = function (e) {
            e.preventDefault();
            var onVerifyToken = _this.props.onVerifyToken;
            var token = _this.state.token;
            onVerifyToken(token);
        };
        _this.onTryAnotherWayClick = function () {
            _this.toggleShowRequestToken();
        };
        _this.toggleShowRequestToken = function () {
            _this.setState({
                showRequestToken: !_this.state.showRequestToken
            });
        };
        _this.onVerify = function (token) {
            _this.setState({
                isNotARobot: true,
                recaptchaToken: token
            });
        };
        _this.onExpire = function () {
            _this.setState({
                isNotARobot: false
            });
        };
        _this.onSendClick = function () {
            _this.props.onRequestTwoFactorToken(_this.state.recaptchaToken);
            _this.toggleShowRequestToken();
        };
        _this.state = { token: "", recaptchaToken: "", isNotARobot: false, showRequestToken: false };
        return _this;
    }
    TwoFactorForm.prototype.render = function () {
        var _a = this.props, error = _a.error, title = _a.title, onLoginClick = _a.onLoginClick, siteKey = _a.siteKey, onRequestTwoFactorToken = _a.onRequestTwoFactorToken;
        var _b = this.state, token = _b.token, showRequestToken = _b.showRequestToken, isNotARobot = _b.isNotARobot;
        return (React.createElement("div", { className: basicTheme.container },
            React.createElement("div", { className: basicTheme.label }, title),
            React.createElement("div", { style: { margin: "0 0 2rem 0", fontSize: "1.4rem" } }, "Enter the code generated by your Authentication App or Email."),
            React.createElement(ui_1.Form, { onSubmit: this.onVerifyToken, className: basicTheme.form, submitOnEnter: true },
                React.createElement(ui_1.AggregateChangeComponent, { onChange: this.onInputChange },
                    React.createElement(ui_1.FormInput, { value: token, name: "token", className: theme.token, label: "TFA Code", required: true, fill: true, type: "text", autoFocus: true })),
                React.createElement(ui_1.Button, { className: basicTheme.button, type: "submit", blue: true, uppercase: true, fill: true, large: true }, "Submit"),
                onRequestTwoFactorToken ? (React.createElement("div", { className: theme.link },
                    React.createElement(linkButton_1.default, { blue: true, type: "button", onClick: this.onTryAnotherWayClick }, "Use email for authentication"))) : null),
            error ? (React.createElement("div", { className: basicTheme.error }, "Failed to verify.")) : null,
            React.createElement(LoginLink, { onLogin: onLoginClick }),
            onRequestTwoFactorToken ? (React.createElement(modal_1.default, { onClose: this.toggleShowRequestToken, isOpen: showRequestToken, title: "Request TFA Code", panel: true, windowClass: theme.window },
                React.createElement("p", null, "You will receive a TFA code via email."),
                React.createElement("div", { className: theme.recaptcha },
                    React.createElement(Recaptcha, { sitekey: siteKey, size: "normal", render: "explicit", theme: "light", verifyCallback: this.onVerify, onloadCallback: function () { }, expiredCallback: this.onExpire })),
                React.createElement("div", { className: theme.buttons },
                    React.createElement(ui_1.Button, { className: theme.button, onClick: this.toggleShowRequestToken, uppercase: true, medium: true }, "Cancel"),
                    React.createElement(ui_1.Button, { className: theme.button, onClick: this.onSendClick, disabled: !isNotARobot, blue: true, uppercase: true, medium: true }, "Send")))) : null));
    };
    TwoFactorForm.defaultProps = {
        title: "Two Factor Authentication"
    };
    return TwoFactorForm;
}(React.Component));
exports.default = TwoFactorForm;
